import React, {useState, useRef} from 'react';
import {Link, useParams} from "react-router-dom";
import DisplayMetaWithImport from "../components/DisplayMetaWithImport.comp";
import {formatDate} from "../../../utils/utils";

import {
    v3Level3Dimension
} from "../../../services/metadata.service";


const columns = [
    {name: 'DQM#', key: 0, json_key: 'dqm_no', data_key: 'dqm_no'},
    {name: 'Stakeholder#', key: 1, json_key: 'stakeholder_no', data_key: 'stakeholder_no'},
    {name: 'Code', key: 2, json_key: 'code', data_key: 'code'},
    {name: 'Name', key: 3, json_key: 'full_name', data_key: 'full_name'},
    {name: 'Definition', key: 4, json_key: 'definition', data_key: 'definition'},
    {name: 'Structure', key: 5, json_key: 'structure', data_key: 'structure'},
    {name: 'Goals', key: 6, json_key: 'goals', data_key: 'goals'},
]


const
    tableCols = [
        {
            label: 'DQM#',
            field: 'dqm_no', width: 150
        },
        {
            label: 'Stakeholder#',
            field: 'stakeholder_no', width: 150
        },
        {
            label: 'Code',
            field: 'code', width: 150
        },
        {
            label: 'Full Name',
            field: 'full_name', width: 150
        },
        {
            label: 'Definition',
            field: 'definition', sort: 'disabled', width: 150
        },
        {
            label: 'Created',
            field: 'createdAt', width: 150
        },
        {
            label: 'Updated',
            field: 'updatedAt', width: 150
        },
        {
            label: 'Actions',
            field: 'actions', sort: 'disabled', searchable: false
        }
    ]


export default function Level3DimensionPage() {

    const { url_param_str } = useParams();
    const search_query = url_param_str.split('=').length > 1 ? url_param_str.split('=')[1]  : '';

    // --- Server-side pagination state ---
    const [serverPage, setServerPage] = useState(1);
    const [serverLimit, setServerLimit] = useState(10);
    const [serverTotal, setServerTotal] = useState(0);
    const [serverTotalPages, setServerTotalPages] = useState(1);

    // --- Server-side search state (debounced) ---
    const [serverSearch, setServerSearch] = useState(search_query || '');
    const [debouncedSearch, setDebouncedSearch] = useState(search_query || '');
    const debounceTimer = useRef(null);

    const handleServerSearchChange = (newSearch) => {
        setServerSearch(newSearch);
        if (debounceTimer.current) clearTimeout(debounceTimer.current);
        debounceTimer.current = setTimeout(() => {
            setDebouncedSearch(newSearch);
            setServerPage(1);
        }, 400);
    };

    const fetchPage = async (page, limit, search) => {
        const result = await v3Level3Dimension.listData(page, limit, search);
        if (result && result.data) {
            const { total, page: pg, limit: lm, total_pages } = result.data;
            const clampedPage = total_pages > 0 && pg > total_pages ? total_pages : pg;
            setServerPage(clampedPage || 1);
            setServerLimit(lm || limit);
            setServerTotal(total || 0);
            setServerTotalPages(total_pages || 1);
        }
        return result;
    };

    const handleServerPageChange = (newPage) => { setServerPage(newPage); };
    const handleServerLimitChange = (newLimit) => { setServerPage(1); setServerLimit(newLimit); };

    const paginatedListAPI = async () => fetchPage(serverPage, serverLimit, debouncedSearch);

    const table_row__additional_rendering = (row) => {
        const create_data = formatDate(row.createdAt) + ',\n ' + (row.createdBy ? row.createdBy : '');
        row.createdAt = create_data;

        const update_data = formatDate(row.updatedAt) + ',\n ' + (row.updatedBy ? row.updatedBy : '');
        row.updatedAt = update_data;

        return row;
    }

    return (
        <DisplayMetaWithImport
            title={'Level3 Dimension'}
            modal_title={'Level3 Dimension - Data Preview'}
            sheet_name={'Level3 (Dimension)'}
            columns={columns}
            tableCols={tableCols}
            tableSpRender={table_row__additional_rendering}
            search_query={search_query}
            listAPI={paginatedListAPI}
            postAPI={v3Level3Dimension.postData}
            deleteAPI={v3Level3Dimension.deleteEntity}
            updateAPI={v3Level3Dimension.updateEntity}
            preRemoveAPI={v3Level3Dimension.preRemoveCheck}
            serverSidePagination={true}
            serverPage={serverPage}
            serverLimit={serverLimit}
            serverTotal={serverTotal}
            serverTotalPages={serverTotalPages}
            onServerPageChange={handleServerPageChange}
            onServerLimitChange={handleServerLimitChange}
            serverSideSearch={true}
            serverSearch={serverSearch}
            onServerSearchChange={handleServerSearchChange}
            debouncedSearch={debouncedSearch}
        />
    );
}
